import { Schema } from 'effect';
import { SiteId } from './common.js';
/** DTO schemas for the /invoice group. See http/payment.ts for conventions. */
export const EligibilityParams = Schema.Struct({ siteId: SiteId });
export const EligibilityResponse = Schema.Struct({
    // The invoice config doc is passed through as stored.
    config: Schema.Any,
    userStatus: Schema.Struct({
        unpaidCount: Schema.Number,
        outstandingAmount: Schema.Number,
        hasOverdue: Schema.Boolean
    })
});
//# sourceMappingURL=invoice.js.map